import React from 'react';
import { Rss } from 'lucide-react';

const AUTH_BG_IMAGE =
  'https://images.unsplash.com/photo-1659007747399-c1eb7acec11c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxwYXN0ZWwlMjBwaW5rJTIwYWJzdHJhY3QlMjBnZW9tZXRyaWN8ZW58MHx8fHwxNzc2MDMzNzg5fDA&ixlib=rb-4.1.0&q=85';

export function AuthLayout({ heroText, children }) {
  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#FFF0F5' }}>
      {/* Left side - decorative */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden border-r-2 border-black">
        <img src={AUTH_BG_IMAGE} alt="Abstract background" className="w-full h-full object-cover" />
        <div className="absolute inset-0 flex items-center justify-center bg-black/20">
          <div className="brutalist-card bg-white p-8 max-w-md">
            <div className="flex items-center gap-3 mb-4">
              <Rss strokeWidth={2.5} size={32} className="text-pink-500" />
              <h1 className="text-4xl font-black tracking-tight uppercase">FEEDBOX</h1>
            </div>
            <p className="text-zinc-600 font-medium leading-relaxed">{heroText}</p>
          </div>
        </div>
      </div>

      {/* Right side - form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <Rss strokeWidth={2.5} size={28} className="text-pink-500" />
            <h1 className="text-3xl font-black tracking-tight uppercase">FEEDBOX</h1>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
